export default __webpack_public_path__ + "static/media/logo_relish.fd352c8d.png";